import { ToastrService } from 'ngx-toastr';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnIncident, SnIncidentMedia } from '@lib/api/entities';
import { SnIncidentsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

import { SnIncidentFieldsGenerator } from '../../services/incident-fields-generator.service';

@Component({
  selector: 'sn-incident-media-dialog',
  templateUrl: './incident-media-dialog.component.html',
  styleUrls: ['./incident-media-dialog.component.scss'],
})
export class IncidentMediaDialogComponent implements OnDestroy {
  public readonly form = new UntypedFormGroup({});
  public readonly formFields: SnFormFieldConfig[] = [
    this._incidentFieldsGenerator.getFileUploadField({
      className: 'incident-media',
    }),
  ];

  public formModel: any = {};
  public isLoading = false;
  public media: SnIncidentMedia[];

  private readonly _destroy$ = new Subject<void>();
  constructor(
    private readonly _incidentsAPI: SnIncidentsAPI,
    private readonly _incidentFieldsGenerator: SnIncidentFieldsGenerator,
    private readonly _dialogRef: MatDialogRef<IncidentMediaDialogComponent>,
    private readonly _toastService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public readonly incident: SnIncident,
  ) {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this.isLoading = true;
    const data = this.form.value;
    const request$ = [];

    Object.entries(data).forEach(([key, value]: any) => {
      value.forEach((file) => {
        file.description = file.name;
        request$.push(this._incidentsAPI.getS3CredsAndUpload(this.incident.id, file));
      });
    });

    forkJoin([...request$])
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: () => {
          this.isLoading = false;
          this._toastService.success(t('vault.incidents.service.mediaSentToVault'));
          this._dialogRef.close();
        },
        error: () => {
          this.isLoading = false;
          this._toastService.error(t('vault.incidents.service.couldNotSendMedia'));
          this._dialogRef.close();
        },
      });
  }

  public cancel(): void {
    this._dialogRef.close();
  }
}
